import { Component, ChangeDetectionStrategy, inject, input, output, computed } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  AssistOrderGridItem,
  ConfigService,
  ORDER_EVENT_STATUSES,
  OrderEventStatus,
  Service,
} from '@assist/shared/data';
import { cueSearch, IconComponent } from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { ImageHeightPipe, LocalizedStringPipe } from '@cue/utilities';
import { DateFormatPipe, TimeFormatPipe } from '@cue/pipes';
import { NgClass, NgStyle } from '@angular/common';

interface Detail extends AssistOrderGridItem {
  groups: {
    service: Service;
    count: number;
  }[];
  statusBadges: {
    status: OrderEventStatus;
    text: string;
    cssClass: string;
  }[];
}

@Component({
  selector: 'assist-order-item-card',
  templateUrl: './order-item-card.component.html',
  styleUrls: ['./order-item-card.component.scss'],
  imports: [
    TranslocoPipe,
    IconComponent,
    DateFormatPipe,
    TimeFormatPipe,
    ImageHeightPipe,
    LocalizedStringPipe,
    NgStyle,
    NgClass,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderItemCardComponent {
  private configService = inject(ConfigService);
  detailClicked = output<void>();
  cueSearch = cueSearch;
  translation = translation;

  gridOrder = input.required<AssistOrderGridItem>();
  detail = computed<Detail>(() => {
    const value = this.gridOrder();
    const allServices = value.orders.reduce(
      (acc, it) => [...acc, ...it.items.reduce((acc2, it2) => [...acc2, it2.serviceId], [] as number[])],
      []
    );

    const groups: { [key: number]: number } = {};

    allServices.forEach((num) => {
      if (!groups[num]) {
        groups[num] = 0;
      }
      groups[num]++;
    });

    return {
      ...value,
      groups: Object.keys(groups).map((key: any) => ({
        count: groups[key],
        service: this.configService.value.services.find((x) => x.id == key),
      })),
      statusBadges: ORDER_EVENT_STATUSES.filter((option) => value.statuses?.includes(option.value.status)).map(
        (option) => ({
          status: option.value.status,
          text: option.text,
          cssClass: option.value.class,
        })
      ),
    };
  });
}
